import React from 'react';
import Button from 'src/components/Buttons/Button';
import { useRouteMatch, Link } from 'react-router-dom';
import { Routes } from 'src/routes';
import { useMediaQuery, useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import { Theme } from '@mui/material/styles/createTheme';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    header: {
      display: 'flex'
    },
    getStarted: {
      marginRight: theme.spacing(1),
      width: '200px',
      display: 'flex',
      alignItems: 'center'
    }
  })
);
const HeaderAuthButton: React.FC<{}> = () => {
  const isLogin = useRouteMatch(Routes.login);
  const isSignup = useRouteMatch(Routes.signup);

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('sm'));
  const matchesLg = useMediaQuery(theme.breakpoints.down('lg'));
  const classes = useStyles()
  return (
    <Grid className={classes.header}>
      {(isSignup || isLogin) && !matchesLg && <Box className={classes.getStarted}>
        <Typography fontSize={14} component="span" fontWeight={600} lineHeight="initial">
          {isSignup ? 'Already have an account?' : "Don't have an account?"}
        </Typography>
      </Box>}
      <Box>
        <Button
          component={Link}
          variant={isLogin ? "contained" : "outlined"}
          px={17}
          py={matches ? 7 : 10}
          styles={{ fontWeight: '500', fontSize: 14 }}
          text={isLogin ? 'Get started' : 'Log in'}
          to={isLogin ? Routes.signup : Routes.login}
        />
      </Box>
    </Grid>
  );
};

export default HeaderAuthButton;
